<div>
    <app-text-search-field *ngIf="!isSavedSearchMode"
                           label="Basic Search Mode"
                           [placeholder]="defaultSearchRequest?.BasicSearchDescription"
                           [textSearchPattern]="defaultSearchRequest?.BasicSearchString">
    </app-text-search-field>
    <app-chip-selector #searchRequestSelector
                       [ngClass]="[isSavedSearchMode ? '' : 'search-request-selector-invisible']"
                       label="Saved Search Mode" 
                       className="width-medium-narrow"
                       [isMultiSelect]="false"
                       [availableItems]="availableSearchRequests"
                       [value]="selectedSearchRequestIds"
                       [disabled]="disabled">
    </app-chip-selector>
    &nbsp;
    &nbsp;
    <button *ngIf="!isSavedSearchMode" mat-button (click)="searchRequested()" [disabled]="disabled">
        <mat-icon class="material-symbols-outlined">
            search
        </mat-icon>
        SEARCH
    </button>
    <button mat-button (click)="toggleSearchMode()" [disabled]="disabled">
        <!--<mat-icon class="material-symbols-outlined">
            {{ isSavedSearchMode ? 'frame_inspect' : 'search' }}
        </mat-icon>-->
        TOGGLE MODE
    </button>
    <button *ngIf="selectedSearchRequests && selectedSearchRequests.length > 0 && selectedSearchRequests[0].IsDefault == false" mat-button (click)="setCurrentSearchAsDefault()">
        SET AS DEFAULT
    </button>
    <button *ngIf="(defaultSearchRequest?.BasicSearchString.SearchString != '' || (!defaultSearchRequest.BasicSearchString.IsWildPrefix) || (!defaultSearchRequest.BasicSearchString.IsWildSuffix)) && !isSavedSearchMode" mat-button (click)="newSavedSearch()">
        <mat-icon class="material-symbols-outlined">
            save
        </mat-icon>
        SAVE
    </button>
</div>
